import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './qoute-card-v2.component.scss';
var QouteCardV2 = /** @class */ (function (_super) {
    tslib_1.__extends(QouteCardV2, _super);
    function QouteCardV2(element) {
        return _super.call(this, element) || this;
    }
    QouteCardV2.prototype.init = function () {
    };
    QouteCardV2.prototype.bindEvents = function () {
    };
    return QouteCardV2;
}(Base));
export { QouteCardV2 };



//////////////////
// WEBPACK FOOTER
// ./components/qoute-card-v2/qoute-card-v2.component.ts
// module id = 675
// module chunks = 0